import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  PhoneNumberPriceInterface,
  setEditId,
  setEditError,
  selectPhoneNumberPriceById
} from "src/store/callrecorder/phoneNumberPricesSlice";
import {
  updatePhoneNumberPrice,
  fetchPhoneNumberPrice
} from "src/actions/callrecorder/phoneNumberPricesActions";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.callrecorder.phoneNumberPrices.editId);
  const error   = useAppSelector(state => state.callrecorder.phoneNumberPrices.editError);
  const price   = useAppSelector(state => selectPhoneNumberPriceById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchPhoneNumberPrice(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: PhoneNumberPriceInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: PhoneNumberPriceInterface) {
    const resultAction = await dispatch(updatePhoneNumberPrice({ id, data }));

    if (updatePhoneNumberPrice.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-phone-number-price'>
        <h6 className="v-content-label">Edit Number Price</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={price} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
